import React from "react";
import {
  Facebook,
  GitHub,
  Twitter,
  Instagram,
  WhatsApp,
  Mail,
  LinkedIn,
} from "@material-ui/icons/";
import "./Footer.css";
export default function Footer({ darkMode }) {
  return (
    <div className={`Footer ${darkMode ? "dark" : "light"}`}>
      <div className="fork">
        <a href="https://github.com/San1ay/covid19-tracker">
          <GitHub
            fontSize="small"
            // style={{ color: "red" }}
            color={`${darkMode ? "secondary" : "primary"}`}
          />
          <span>Fork it on GitHub</span>
        </a>
      </div>
      <h1>Contact Me</h1>
      <div className="link-container">
        <div className="link">
          <a href="mailto:mail@sanjaysingh.com.np">
            <Mail fontSize="small" />
            <span>Mail</span>
          </a>
        </div>
        <div className="link">
          <a href="https://github.com/San1ay/">
            <GitHub
              fontSize="small"
              color={`${darkMode ? "secondary" : "primary"}`}
            />
            <span>GitHub</span>
          </a>
        </div>
        <div className="link">
          <a href="https://www.linkedin.com/in/San7ay/">
            <LinkedIn fontSize="small" color="primary" />
            <span>LinkedIn</span>
          </a>
        </div>
        <div id="break" />
        <div className="link">
          <a href="https://www.facebook.com/SanjayErrr">
            <Facebook fontSize="small" color="primary" />
            <span>Sānjāy</span>
          </a>
        </div>
        <div className="link">
          <a href="https://twitter.com/san7ay_">
            <Twitter fontSize="small" color="primary" />
            <span>Sanjay</span>
          </a>
        </div>
        <div className="link">
          <a href="https://www.instagram.com/san7ay_/ ">
            <Instagram fontSize="small" color="primary" />
            <span> San7ay_ </span>
          </a>
        </div>

        <div className="link">
          <a href="https://api.whatsapp.com/send?phone=9779805992950">
            <WhatsApp fontSize="small" style={{ color: "green" }} />
            <span>Whatsapp</span>
          </a>
        </div>
      </div>
    </div>
  );
}
